export enum SurveyStatus {
  Active = 'active',
  Inactive = 'inactive',
  Draft = 'draft',
}
